<template>
    <div>
        <b-form-group label="Question" label-for="question">
            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Options" label-for="options" class="mb-2">
            <div v-for="(answer, index) in editable_content.possible_answers" :key="answer.id" class="mb-1">
                <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                        <b-input-group>
                            <b-input-group-prepend class="text-capitalize" is-text>
                                <div class="answer-option">{{answer.option}}</div>
                            </b-input-group-prepend>

                            <b-input-group-prepend is-text>
                                <b-form-checkbox
                                    class="mr-n2"
                                    :id="'checkbox' + answer.option"
                                    :disabled="!answer.value"
                                    :checked="isAnswer(answer.option)"
                                    :state="validating && (!editable_content.answers || editable_content.answers && !editable_content.answers.length) ? false : null"
                                    @change="toggleAnswer(answer.option)"
                                >
                                </b-form-checkbox>
                            </b-input-group-prepend>

                            <TipTap
                                v-model="answer.value"
                                :class="{'is-invalid': validating && !answer.value, 'form-control': true}"
                                :menu_type="'wysiwyg_menu_type'"
                                :hide_word_count="true"
                                :show_related_media_modal="answer.show_add_related_media_modal"
                                @closeSbpModal="answer.show_add_related_media_modal = false"
                            />

                            <b-input-group-append>
                                <b-btn variant="info" content="Add SBP Image" v-tippy="{placement: 'top'}" @click="answer.show_add_related_media_modal = true">
                                    SBP
                                </b-btn>
                            </b-input-group-append>

                        </b-input-group>
                    </div>
                    <div v-if="(index > 2)" class="ml-2">
                        <b-btn variant="link" class="text-danger" @click.prevent="removeOption(index, answer.option)">
                            <font-awesome-icon :icon="['far', 'times']" />
                        </b-btn>
                    </div>
                </div>
                <b-form-invalid-feedback :state="validating && !answer.value ? false : null">
                    Option text is required
                </b-form-invalid-feedback>
            </div>

            <b-form-invalid-feedback :state="validating && !editable_content.answers.length ? false : null">
                At least 1 answer is required
            </b-form-invalid-feedback>

        </b-form-group>

        <div class="mb-3">
            <b-btn size="sm" variant="outline-primary" @click.prevent="addOption">
                <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Option
            </b-btn>
        </div>
    </div>
</template>

<style scoped>
.answer-option {
    min-width: 15px;
}
.form-control {
    height: auto;
}
.form-control >>> .editor-content {
    border: none;
}
.form-control >>> .ProseMirror {
    padding: 0;
    min-height: 60px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        editable_content: {
            question: '',
            possible_answers: [
                {id: Math.floor(Math.random() * 1000000), option: 'a', show_add_related_media_modal: false, value: ''},
                {id: Math.floor(Math.random() * 1000000), option: 'b', show_add_related_media_modal: false, value: ''},
                {id: Math.floor(Math.random() * 1000000), option: 'c', show_add_related_media_modal: false, value: ''},
                {id: Math.floor(Math.random() * 1000000), option: 'd', show_add_related_media_modal: false, value: ''}
            ],
            answers: []
        },
        letters: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k']
    }),
    props: [
        'question',
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        addOption () {
            let length = this.editable_content.possible_answers.length
            this.editable_content.possible_answers.push({
                id: Math.floor(Math.random() * 1000000),
                option: this.letters[length],
                show_add_related_media_modal: false,
                value: ''
            })
        },
        removeOption (index, option) {
            this.editable_content.possible_answers.splice(index, 1)
            this.editable_content.answers = []
            _.each(this.editable_content.possible_answers, (answer, index) => {
                answer.option = this.letters[index]
            })
        },
        isAnswer (option) {
            let is_answer = false

            if (_.includes(this.editable_content.answers, option)) {
                is_answer = true
            }

            return is_answer
        },
        toggleAnswer (option) {
            if (_.includes(this.editable_content.answers, option)) {
                const index = this.editable_content.answers.findIndex(answer => answer == option)
                this.editable_content.answers.splice(index, 1)
            } else {
                this.editable_content.answers.push(option)
            }
        }
    },
    created() {
        if (this.question && this.question.content) {
            let q = _.cloneDeep(this.question)
            this.$set(this.editable_content, 'possible_answers', q.content.possible_answers)
            this.$set(this.editable_content, 'answers', q.content.answers)
            this.$set(this.editable_content, 'question', q.content.question)
            _.each(this.editable_content.possible_answers, answer => {
                this.$set(answer, 'id', Math.floor(Math.random() * 1000000))
                this.$set(answer, 'show_add_related_media_modal', false)
            })
        }
    }
}
</script>
